import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=a29e6b90&scoped=true"
import script from "./ViewItem.vue?vue&type=script&lang=js"
export * from "./ViewItem.vue?vue&type=script&lang=js"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=a29e6b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29e6b90",
  null
  
)

export default component.exports